"use client"

import { useEffect, type RefObject } from "react"

export const useCloseWhenScrolledAway = <T extends HTMLElement>(ref: RefObject<T | null>, open: boolean, onClose: () => void) => {
  useEffect(() => {
    if (!open) return
    const onScroll = () => {
      const element = ref.current
      if (element && element.getBoundingClientRect().bottom <= 0) onClose()
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [ref, open, onClose])
}
